import { useEffect, useState } from "react";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserSubscriptionHistory, getUserSubscriptionList } from "../../features/subscriptionSlice";
import Button from "../../components/button/Button";
import { largeModalShowHide, setTitle } from "../../features/modalSlice";
import { LargeModal } from "../../components/modal/ModalUI";
import PlanHistoryModal from "./PlanHistoryModal";

const UserSubscription = () => {
    const dispatch = useDispatch();
    const { userSubscriptionList } = useSelector((state) => state.subscription);
    const [searchText, setSearchText] = useState('');
    const limit = 10;
    const offset = 0;

    useEffect(() => {
        const payload = { offset, limit, searchText };
        dispatch(getUserSubscriptionList(payload));
    }, [offset, limit, searchText, dispatch]);

    const viewMoreDetails = (i, body) => {
        const list = userSubscriptionList[i];
        if (body === "details") {
            dispatch(fetchUserSubscriptionHistory({ user_id: list.user_id }))
            dispatch(setTitle("User Subscription History"));
        }
        dispatch(largeModalShowHide());
    };

    return (
        <div id="main" className="main">
            <Breadcrumb page="User Subscription List" />
            <section className="section">
                <div className="row mb-3">
                    <div className="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-between align-items-center">
                        <div className='d-flex align-items-center gap-2 item_list'>
                            <h6 className="card-title m-0 p-0">Subscription List</h6>
                            <input className='form-control' placeholder='search' type='text' name='search' value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                        </div>
                    </div>
                </div>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th
                                scope="col"
                                className="text-center fs-7"
                            >
                                User Name
                            </th>
                            <th
                                scope="col"
                                className="text-center fs-7"
                            >
                                email
                            </th>
                            <th
                                scope="col"
                                className="text-center fs-7"
                            >
                                Subscription Plan
                            </th>
                            <th
                                scope="col"
                                className="text-center fs-7"
                            >
                                Plan Type
                            </th>
                            <th
                                scope="col"
                                className="text-center fs-7"
                            >
                                Amount
                            </th>
                            <th
                                scope="col"
                                className="text-center fs-7"
                            >
                                Start Date
                            </th>
                            <th
                                scope="col"
                                className="text-center fs-7"
                            >
                                End Date
                            </th>
                            <th
                                scope="col"
                                className="text-center fs-7"
                            >
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {userSubscriptionList && userSubscriptionList.length
                            ? userSubscriptionList.map((item, i) => (
                                <tr
                                    key={`subscriptionList-${i}`}
                                >
                                    <td className="text-center fs-7" width="10%">
                                        {item.user_name}
                                    </td>
                                    <td className="text-center fs-7 align-middle">
                                        {item.user_email}
                                    </td>
                                    <td className="text-center fs-7 align-middle">
                                        {item.subscription_name}
                                    </td>
                                    <td className="text-center fs-7 align-middle">
                                        {item.subscription_type}
                                    </td>
                                    <td className="text-center fs-7 align-middle">
                                        {"$" + item.subscription_amount}
                                    </td>
                                    <td className="text-center fs-7 align-middle">
                                        {item.start_date}
                                    </td>
                                    <td className="text-center fs-7 align-middle">
                                        {item.end_date}
                                    </td>
                                    <td className="text-center fs-7 align-middle">
                                        <Button className="btn btn-outline-success btn-sm fs-7 me-2" onClick={() => viewMoreDetails(i, "details")}>
                                            <i className="fa-regular fa-eye"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))
                            : null}
                    </tbody>
                </table>
            </section>
            <LargeModal><PlanHistoryModal /></LargeModal>
        </div>
    );
}
export default UserSubscription;